import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { contentPage } from 'src/services/ContentApi'
import PropTypes from 'prop-types'
import Loader from 'src/components/Loader'
import SetInnerHtml from 'src/components/SetInnerHtml'

const TermsOfUse = ({ className = 'container' }) => {
  const [myData, setMyData] = useState({})
  const [loader, setLoader] = useState(false)
  const language = useSelector((state) => state.language)

  useEffect(() => {
    const getData = async () => {
      setLoader(true)
      try {
        const data = await contentPage('page_TermsofUse', language)
        setMyData(data)
      } catch (error) {
        console.error(error)
      }
      setLoader(false)
    }
    getData()
  }, [language])

  const printterms = () => {
    const mywindow = window.open('', '_blank')
    mywindow.document.write('<p>' + document.getElementById('sprint').innerHTML + '</p>')
    mywindow.print()
    mywindow.close()
  }

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <p className="text-end" style={{ padding: '10px 30px 0', margin: 0 }}>
            <Link to="#" className="fa fa-print" onClick={printterms} aria-hidden="true" />
          </p>
          <section className="helpline-container" id="sprint">
            <h2 style={{ textAlign: 'center' }}>{myData.txt_bannertitle}</h2>
            <div className={className}>
              <div className="row">
                <div>
                  <SetInnerHtml tag="span" content={myData.html_content} />
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  )
}

TermsOfUse.propTypes = {
  className: PropTypes.string,
}

export default TermsOfUse
